import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarOpen: false,
    docStructure: [
      {
        title: '入门指南',
        children: [
          { slug: '1', title: '简介' },
          { slug: '2', title: '快速入门' },
        ]
      },
      {
        title: '核心功能',
        children: [
          { slug: '3.1', title: 'PDF转换功能' },
          { slug: '3.2', title: 'PDF翻译功能' },
          { slug: '3.3', title: 'PDF操作功能' }
        ]
      },
      {
        title: 'API参考',
        children: [
          { slug: '4.1', title: '主要类和接口' },
          { slug: '4.2', title: '请求参数' },
          { slug: '4.3', title: '响应对象' },
          { slug: '4.4', title: '错误处理' },
          { slug: '4.5', title: '配置选项' }
        ]
      },
      {
        title: '高级主题',
        children: [
          { slug: '5', title: '高级用法' }
        ]
      },
      {
        title: '常见问题解答',
        children: [
          { slug: '6', title: '示例代码' }
        ]
      },
      {
        title: '示例代码',
        children: [
          { slug: '7', title: '示例代码' }
        ]
      },
      {
        title: '附录',
        children: [
          { slug: '8', title: '附录' },
          { slug: '9', title: '联系我们' }
        ]
      }
    ]
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen
    },
    closeSidebar(state) {
      state.sidebarOpen = false
    }
  },
  actions: {},
  getters: {
    getDocBySlug: (state) => (slug) => {
      for (const section of state.docStructure) {
        for (const doc of section.children) {
          if (doc.slug === slug) {
            return doc
          }
        }
      }
      return null
    },
    getDocNavigation: (state) => (currentSlug) => {
      const allDocs = state.docStructure.flatMap(section => section.children)
      const currentIndex = allDocs.findIndex(doc => doc.slug === currentSlug)
      
      return {
        prev: currentIndex > 0 ? allDocs[currentIndex - 1] : null,
        next: currentIndex < allDocs.length - 1 ? allDocs[currentIndex + 1] : null
      }
    }
  }
})